import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { catchError, mergeMap, switchMap, tap } from 'rxjs/operators';

import { PLAYLIST_ENDPOINT_URL, PLAYLIST_REQUEST_TIMEOUT } from '../../../common/constants/request';
import { CHANNEL_LIST_PATH, DEFAULT_VIEW_PATH } from '../../../common/constants/routePath';

import { getPathNameByParams, replace } from '../../../common/helpers/history';
import { includeFeatures, tmPostRequest } from '../../../common/helpers/request';
import { getChannelUrl } from '../../../common/helpers/url';
import { getFormattedVideo } from '../../../common/helpers/video';
import * as commonSelectors from '../../../common/redux/selectors/common';
import {
  additionalVideoFetchStartedAction,
  additionalVideoFetchSuccessAction,
} from '../../../common/redux/slices/common';
import { setLoadingStateAction } from '../slices/additional';

export default (action$, state$) =>
  action$.pipe(
    ofType(additionalVideoFetchStartedAction.type),
    switchMap(({ payload: { video, targetChannel, params, querySearchString } }) => {
      const basePath = commonSelectors.basePathSelector(state$.value);
      const publisher = commonSelectors.publisherSelector(state$.value);
      const player = commonSelectors.playerSelector(state$.value);

      const redirectTo = () => {
        const channel = commonSelectors.channelsSelector(state$.value).find(({ id }) => id === targetChannel.id);

        replace(
          channel?.playlist?.length
            ? {
                pathname: getPathNameByParams(DEFAULT_VIEW_PATH, {
                  ...params,
                  video: channel.playlist[0].mediaid,
                }),
                search: querySearchString,
              }
            : CHANNEL_LIST_PATH,
        );
      };

      const stream$ = tmPostRequest({
        url: PLAYLIST_ENDPOINT_URL,
        timeout: PLAYLIST_REQUEST_TIMEOUT,
        body: {
          videoHub: true,
          publisherId: publisher.slug,
          widgetId: player.name,
          url: getChannelUrl(basePath, targetChannel.name),
          preids: JSON.stringify([video]),
          ...includeFeatures(state$.value),
        },
      }).pipe(
        mergeMap(({ response }) => {
          const targetVideo = (response?.playlist || [])
            .map((video$) => getFormattedVideo(video$, { signedUrlExp: response.signedUrlExp }))
            .find((video$) => video$.mediaid === video);

          const actions = [of(additionalVideoFetchSuccessAction(targetVideo || null))];

          if (!targetVideo) {
            actions.push(of({ type: '@#' }).pipe(tap(() => redirectTo())));
          }

          return concat(...actions, of(setLoadingStateAction(false)));
        }),
        catchError(() => {
          redirectTo();

          return of(setLoadingStateAction(false));
        }),
      );

      return concat(of(setLoadingStateAction(true)), stream$);
    }),
  );
